import { Card, Col, Row, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import checkTokenExp from "../../../utils/checkTokenExp";
import BirthdayBar from "../../birthday/birthdayBar";
import AttendancePopup from "../../UI/PopUp/AttendancePopup";
import AnnouncementBar from "./AnnouncementBar";

import ChangePassword from "../../user/changePassword";
import DemoLine from "./Demoline";
import PublicHolidayBar from "./PublicHolidayBar";
import { loadDashboardData } from "../../../redux/rtk/features/dashboard/dashboardSlice";
import { useDispatch, useSelector } from "react-redux";
import getUserFromToken from "../../../utils/getUserFromToken";
import ResetPassword from "../../user/resetPassword";
import WorkAnniversary from "../../Anniversary/WorkAnniversary";
import MarriageAnniversary from "../../Anniversary/MarriageAnniversaryBar";

const { TabPane } = Tabs;

const Dashboard = () => {
  const [passwordModalVisible, setPasswordModalVisible] = useState(false);
  const [dashboardVisible, setDashboardVisible] = useState(true);
  const [defaultActiveKey, setDefaultActiveKey] = useState("1");
  
  const isLogged = Boolean(localStorage.getItem("isLogged"));
  const RequirePasswordChange = localStorage.getItem("RequirePasswordChange");
  // console.log("passwordChanged", RequirePasswordChange);
  const dashboardData = useSelector((state) => state.dashboard.list);
  // console.log("dashboardData", dashboardData);
  const EmployeeId = getUserFromToken();

  const todayStatus = dashboardData?.TodayStatus
  // // console.log("todayStatus", todayStatus);
  
  
  const dispatch = useDispatch();
 useEffect(() => {
    // Get current date in YYYY-MM-DD format
    const currentDate = new Date().toISOString().split("T")[0];
    // Dispatch the loadDashboardData action with the specified payload
    const payload = {
      EmployeeId: EmployeeId,
      CustomDate: currentDate,
    };
    dispatch(loadDashboardData(payload));
  }, [dispatch]);

  useEffect(() => {
    // Check if password needs to be changed
    if (RequirePasswordChange === "true") {
      setPasswordModalVisible(true);
      setDashboardVisible(false);
    } else {
      setDashboardVisible(true);
    }
  }, [RequirePasswordChange]);

  // Function to check if a tab has data
  const hasData = (tabKey) => {
    switch (tabKey) {
      case "1": // Announcements
        return dashboardData?.AnnouncementDetails && dashboardData.AnnouncementDetails.length > 0;
      case "2": // Birthdays
        return dashboardData?.TodayBirthAnniversary?.length > 0 || 
               dashboardData?.UpcommingBirthAnniversary?.length > 0;
      case "3": // Marriage Anniversary
        return dashboardData?.TodayMarriageAnniversary?.length > 0 || 
               dashboardData?.UpcommingMarriageAnniversary?.length > 0;
      case "4": // Work Anniversary
        return dashboardData?.TodayWorkAnniversary?.length > 0 || 
               dashboardData?.UpcommingWorkAnniversary?.length > 0;
      default:
        return false;
    }
  };

  // Effect to determine the default active tab based on available data
  useEffect(() => {
    if (dashboardData) {
      // Define tab order to check
      const tabKeys = ["1", "2", "3", "4"];
      
      // Find the first tab with data
      const firstTabWithData = tabKeys.find(key => hasData(key));
      
      // Set the default active key to the first tab with data, or "1" if none have data
      setDefaultActiveKey(firstTabWithData || "1");
    }
  }, [dashboardData]);

  if (!isLogged) {
    return <Navigate to={"/admin/auth/login"} replace={true} />;
  }

  const accessToken = localStorage.getItem("access-token");
  checkTokenExp(accessToken);

  const roleId = parseInt(localStorage.getItem("roleId"), 10);

  const handlePasswordChange = () => {
    setPasswordModalVisible(false);
    setDashboardVisible(true);
  };

  if (!dashboardVisible) {
    return (
      <ResetPassword
        visible={passwordModalVisible}
        onCancel={handlePasswordChange}
      />
    );
  }

  return (
    <div className="dashboard-page-wrapper">
      <Row gutter={[30, 30]} justify={"space-between"}>
        <Col sm={24} md={24} lg={12} span={24} className="mb-auto"></Col>
        <Col sm={24} md={24} lg={12} span={24}>
          <div className="text-end mr-4">
            <AttendancePopup />
          </div>
        </Col>
      </Row>

      <section className="mt-5 mb-5 dashboard-content-section">
        <div>
          {/* {roleId === 1 && ( */}
            <div className="mb-3">
              <Row>
                <Col span={24}>
                  <DemoLine todayStatus={todayStatus}/>
                </Col>
              </Row>
            </div>
          {/* // )} */}
          <div>
            <Row gutter={[30, 30]}>
              <Col sm={24} md={24} lg={12} span={24} className="mb-auto">
                  <Card title="PUBLIC HOLIDAYS" className="dashboard-card">
                  <PublicHolidayBar holidays={dashboardData?.PublicHolidayDetails || []} />
                </Card>
              </Col>

              <Col sm={24} md={24} lg={12} span={24}>
                <Card className="dashboard-card">
                  <Tabs defaultActiveKey={defaultActiveKey} key={defaultActiveKey}>
                    <TabPane tab="Announcements" key="1">
                      <AnnouncementBar announcements={dashboardData?.AnnouncementDetails || []} />
                    </TabPane>
                    <TabPane tab=" Birthdays" key="2">
                      <BirthdayBar birthdays={dashboardData || []}/>
                    </TabPane>
                    <TabPane tab="Marriage Anniversary" key="3">
                      <MarriageAnniversary anniversary={dashboardData || []}/>
                    </TabPane>
                      <TabPane tab="Work Anniversary" key="4">
                      <WorkAnniversary WorkAnniversary={{
                        TodayWorkAnniversary: dashboardData?.TodayWorkAnniversary || [],
                        UpcomingWorkAnniversary: dashboardData?.UpcommingWorkAnniversary || []
                      }}/>
                    </TabPane>
                  </Tabs>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dashboard;

// import { Card, Col, Row, Tabs } from "antd";
// import React, { useEffect, useState } from "react";
// import { Navigate } from "react-router-dom";
// import checkTokenExp from "../../../utils/checkTokenExp";
// import BirthdayBar from "../../birthday/birthdayBar";
// import AttendancePopup from "../../UI/PopUp/AttendancePopup";
// import AnnouncementBar from "./AnnouncementBar";

// import ChangePassword from "../../user/changePassword";
// import DemoLine from "./Demoline";
// import PublicHolidayBar from "./PublicHolidayBar";
// import { loadDashboardData } from "../../../redux/rtk/features/dashboard/dashboardSlice";
// import { useDispatch, useSelector } from "react-redux";
// import getUserFromToken from "../../../utils/getUserFromToken";
// import ResetPassword from "../../user/resetPassword";
// import WorkAnniversary from "../../Anniversary/WorkAnniversary";
// import MarriageAnniversary from "../../Anniversary/MarriageAnniversaryBar";

// const { TabPane } = Tabs;

// const Dashboard = () => {
//   const [passwordModalVisible, setPasswordModalVisible] = useState(false);
//   const [dashboardVisible, setDashboardVisible] = useState(true);
//   const isLogged = Boolean(localStorage.getItem("isLogged"));
//   const RequirePasswordChange = localStorage.getItem("RequirePasswordChange");
//   // console.log("passwordChanged", RequirePasswordChange);
//   const dashboardData = useSelector((state) => state.dashboard.list);
//   // console.log("dashboardData", dashboardData);
//   const EmployeeId = getUserFromToken();

//   const todayStatus = dashboardData?.TodayStatus
//   // // console.log("todayStatus", todayStatus);
  
  
//   const dispatch = useDispatch();
//  useEffect(() => {
//     // Get current date in YYYY-MM-DD format
//     const currentDate = new Date().toISOString().split("T")[0];
//     // Dispatch the loadDashboardData action with the specified payload
//     const payload = {
//       EmployeeId: EmployeeId,
//       CustomDate: currentDate,
//     };
//     dispatch(loadDashboardData(payload));
//   }, [dispatch]);

//   useEffect(() => {
//     // Check if password needs to be changed
//     if (RequirePasswordChange === "true") {
//       setPasswordModalVisible(true);
//       setDashboardVisible(false);
//     } else {
//       setDashboardVisible(true);
//     }
//   }, [RequirePasswordChange]);

//   if (!isLogged) {
//     return <Navigate to={"/admin/auth/login"} replace={true} />;
//   }

//   const accessToken = localStorage.getItem("access-token");
//   checkTokenExp(accessToken);

//   const roleId = parseInt(localStorage.getItem("roleId"), 10);

//   const handlePasswordChange = () => {
//     setPasswordModalVisible(false);
//     setDashboardVisible(true);
//   };

//   if (!dashboardVisible) {
//     return (
//       <ResetPassword
//         visible={passwordModalVisible}
//         onCancel={handlePasswordChange}
//       />
//     );
//   }

//   return (
//     <div>
//       <Row gutter={[30, 30]} justify={"space-between"}>
//         <Col sm={24} md={24} lg={12} span={24} className="mb-auto"></Col>
//         <Col sm={24} md={24} lg={12} span={24}>
//           <div className="text-end mr-4">
//             <AttendancePopup />
//           </div>
//         </Col>
//       </Row>

//       <section className="mt-5 mb-5">
//         <div>
//           {/* {roleId === 1 && ( */}
//             <div className="mb-3">
//               <Row>
//                 <Col span={24}>
//                   <DemoLine todayStatus={todayStatus}/>
//                 </Col>
//               </Row>
//             </div>
//           {/* // )} */}
//           <div>
//             <Row gutter={[30, 30]}>
//               <Col sm={24} md={24} lg={12} span={24} className="mb-auto">
//                   <Card title="PUBLIC HOLIDAYS" className="">
//                   <PublicHolidayBar holidays={dashboardData?.PublicHolidayDetails || []} />
//                 </Card>
//               </Col>

//               <Col sm={24} md={24} lg={12} span={24}>
//                 <Card>
//                   <Tabs defaultActiveKey="1">
//                     <TabPane tab="Announcements" key="1">
//                       <AnnouncementBar announcements={dashboardData?.AnnouncementDetails || []} />
//                     </TabPane>
//                     <TabPane tab=" Birthdays" key="2">
//                       <BirthdayBar birthdays={dashboardData || []}/>
//                     </TabPane>
//                     <TabPane tab="Marriage Anniversary" key="3">
//                       <MarriageAnniversary anniversary={dashboardData || []}/>
//                     </TabPane>
//                       <TabPane tab="Work Anniversary" key="4">
//                       <WorkAnniversary WorkAnniversary={dashboardData || []}/>
//                     </TabPane>
//                   </Tabs>
//                 </Card>
//               </Col>
//             </Row>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Dashboard;


